export default "__VITE_ASSET__BQAIFQiF__"